<template>
  <div>
    <ModalHeader
      :handleClose="handleClose"
      :headerText="headerText"
      :showClose="true"
    />
    <div :class="$style.modalBody">
      <p>
        Policy applied to
        <strong>{{ policyStatus.system.displayName }}</strong>
        {{ groupNames.length ? 'through membership in the System Group(s):' : '' }}
        <strong>{{ groupNames }}</strong>
      </p>
      <hr>
      <strong
        v-if="policyStatus.stdErr"
      >
        Error:
      </strong>
      <p
        v-if="policyStatus.stdErr && policyStatus.stdErr !== ''"
      >
        {{ policyStatus.stdErr }}
      </p>
      <PolicyStatusDetail
        :policyStatus="policyStatus"
      />
      <strong>Start Time:</strong>
      <p>{{ policyStatus.startedAt }}</p>
      <strong>End Time:</strong>
      <p>{{ policyStatus.endedAt }}</p>
      <strong>Exit Status:</strong>
      <p>{{ policyStatus.exitStatus }}</p>
    </div>
    <ModalFooter
      :handleClose="handleClose"
      :handleMainAction="handleClose"
      mainActionText="ok"
    />
  </div>
</template>

<script>
import { get } from 'lodash';
import ModalEventBus from 'components/Modal/ModalEventBus';
import ModalFooter from 'components/Modal/ModalComponents/ModalFooter.vue';
import ModalHeader from 'components/Modal/ModalComponents/ModalHeader.vue';
import PolicyStatusDetail from 'client/policies/views/PolicyStatusDetail';
import PolicyStatusMixin from 'client/policies/views/PolicyStatusMixin';

export default {
  name: 'PolicyStatusModal',

  components: {
    ModalFooter,
    ModalHeader,
    PolicyStatusDetail,
  },

  mixins: [PolicyStatusMixin],

  props: {
    groupNames: {
      required: true,
      type: String,
    },
    policyStatus: {
      required: true,
      type: Object,
    },
  },

  computed: {
    headerText() {
      return `${get(this.policyStatus, 'system.displayName')} - RESULT LOG`;
    },

    tableData() {
      return Object.values(this.detailObject);
    },
  },

  methods: {
    handleClose() {
      ModalEventBus.close();
    },
  },
};
</script>

<style scoped module>
.modalBody {
  padding: 0 35px;
}

</style>
